(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ri-fit-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ri-measurements')) {
  customElements.define('ri-measurements', class extends HTMLElement {
    connectedCallback() {
      const description = (this.dataset.description || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ');
      const fields = [
        ['Shoulder width', /\bshoulder\s*(?:width)?\s*[-:–]?\s*(\d{1,2}(?:\.\d+)?)\s*\.?\s*(?:inches|inch|in)?\b/i, 6, 40],
        ['Waist', /\bwaist\s*[-:–]?\s*(\d{1,2}(?:\.\d+)?)\s*\.?\s*(?:inches|inch|in)?\b/i, 15, 60],
        ['Length', /\blength\s*[-:–]?\s*(\d{1,2}(?:\.\d+)?)\s*\.?\s*(?:inches|inch|in)?\b/i, 12, 60]
      ];
      const grid = this.querySelector('[data-measurement-grid]');
      let found = 0;
      for (const [label, pattern, minimum, maximum] of fields) {
        const match = description.match(pattern);
        if (!match) continue;
        const amount = Number(match[1]);
        if (!Number.isFinite(amount) || amount < minimum || amount > maximum) continue;
        const cell = document.createElement('div');
        const heading = document.createElement('span');
        const value = document.createElement('strong');
        heading.textContent = label;
        value.textContent = amount + ' in';
        cell.append(heading, value);
        grid.append(cell);
        found++;
      }
      if (found) this.hidden = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
